/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetEquipmentQueryResponse, GetEquipmentPathParams, GetEquipment400, GetEquipment401, GetEquipment403, GetEquipment404, GetEquipment409, GetEquipment500 } from "../../types/equipmentController/GetEquipment.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetEquipmentUrl(organizationId: GetEquipmentPathParams["organizationId"], equipmentId: GetEquipmentPathParams["equipmentId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/${equipmentId}` as const }
  return res
}

/**
 * @summary Get equipment detail
 * {@link /api/organizations/:organizationId/equipment/:equipmentId}
 */
export async function getEquipment(organizationId: GetEquipmentPathParams["organizationId"], equipmentId: GetEquipmentPathParams["equipmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetEquipmentQueryResponse, ResponseErrorConfig<GetEquipment400 | GetEquipment401 | GetEquipment403 | GetEquipment404 | GetEquipment409 | GetEquipment500>, unknown>({ method : "GET", url : getGetEquipmentUrl(organizationId, equipmentId).url.toString(), ... requestConfig })
  return res.data
}